// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"486":"e56cfe34","917":"cc69ff56","961":"070109d3"}[chunkId] + ".js";
};